import { render, staticRenderFns } from "./cardUltPedido.vue?vue&type=template&id=2d6e9842&scoped=true&"
import script from "./cardUltPedido.vue?vue&type=script&lang=js&"
export * from "./cardUltPedido.vue?vue&type=script&lang=js&"
import style0 from "./cardUltPedido.vue?vue&type=style&index=0&id=2d6e9842&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6e9842",
  null
  
)

export default component.exports